import React, { Component } from 'react';

interface Props {
  
}

interface State {
  
}

class CompetitionResult extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      
    };
  }

  
  render() {
    return (
      <div>
        <h1>Hello from Competitions Results</h1>
      </div>
    );
  }
}

export default CompetitionResult;